import Vue from 'vue';
import axios from 'axios';

class Analytics {
  domoId;

  constructor() {
    if (!window.s) {
      console.error('Analytics are not included.');
    } else {
      this.s = window.s;

      if (window.domoAnalytics) {
        this.s.doPlugins = window.domoAnalytics.doPlugins;
      }

      const self = this;

      Vue.directive('trackClick', {
        inserted(el, binding) {
          el.addEventListener('click', () => {
            self.trackLink({
              path: binding.value.path,
              position: binding.value.position,
              name: binding.value.name,
            });
          });
        },
      });

      if (window.anchanchu) {
        this.anchanchu = window.anchanchu;
        window.axios = axios;
        axios.get('/getPartial/domoID').then((response) => {
          const { status, data } = response;
          if (status === 200) {
            window.anchanchu.setDomoId(data);
          }
        });

        axios.get('/getPartial/tier').then((response) => {
          const { status, data } = response;
          if (status === 200) {
            window.anchanchu.setDomoTier(data);
          }
        });
      }

      Vue.prototype.$analytics = this;
    }
  }

  trackLink(params) {
    if (params.name === 'primary-cta' && params.position === 'header') {
      window.anchanchu.trackLink('clicked try free', 'header');
    }

    if (params.name === 'try-free-and-connect') {
      window.anchanchu.trackLink('clicked try free and connect', params.position);
    }

    if (params.position && params.name) {
      this.track('track-link', {
        eVar49: `${params.path} : ${params.name} : ${params.position}`,
      });
    }
  }

  trackSearch(params) {
    const { search } = params;
    if (search) {
      this.track('track-search', {
        eVar52: search,
        prop52: 'D=52',
        events: 'event36',
      });

      this.anchanchu.trackEvent('searched appstore', {
        'appstore search keywords': search,
      });
    }
  }

  trackPage(params) {
    const { pageName, visitorType } = params;
    if (pageName && visitorType) {
      this.s.clearVars();
      this.s.eVar76 = visitorType;
      this.s.pageName = pageName;
      this.s.t();

      this.anchanchu.trackEvent('viewed appstore', {
        pageName,
      });
    }
  }

  track(name, params) {
    if (params) {
      this.s.clearVars();
      Object.keys(params).forEach((key) => {
        this.s[key] = params[key];
      });
      this.s.tl(true, 'o', name);
    }
  }
}

export default {
  install() {
    return new Analytics();
  },
};
